var content_blocks = ( function( $ ) {

	var $accordions;
	var $link_boxes;
	
	var _init = function() {
		$accordions = $( '.accordion.panel-group' );
		$link_boxes = $( '.link-boxes.set-heights' );

		if ( $link_boxes.length > 0 ) {
			_setup_link_box_heights();

			$( window ).smartresize( function() {
				_setup_link_box_heights();
			} );
		}

		$accordions.each( function( index, item ) {
			_setup_classes_toggle( $( item ) );
		} )
	};

	var _setup_link_box_heights = function() {
		var $boxes = $link_boxes.find( '.link-box' ),
			height = 0;

		$boxes.each( function( index, item ) {
			if ( $( item ).outerHeight() > height ) {
				height = $( item ).outerHeight();
			}
		} );

		$boxes.css( 'height', height );
	};

	var _setup_classes_toggle = function( $accordion ) {
		var $panels = $accordion.find( '.panel' );

		$panels.find( '.panel-toggle-link' ).on( 'click', function( e ) {
			$panels.removeClass( 'open' );
		} );

		$panels.each( function( index, item ) {
			var $panel       = $( item ),
				$toggle_link = $panel.find( '.panel-toggle-link' );

			if ( $toggle_link.attr( 'aria-expanded' ) === 'true' ) {
				$panel.addClass( 'open' );
			}

			// Scroll to opened accordion
			$panel.on( 'show.bs.collapse', function( e ) {
				var $open             = $( this ).closest( '.panel-group' ).find( '.panel-collapse.in' );
				var additional_offset = 50;

				if ( $panel.prevAll().filter( $open.closest( '.panel' ) ).length !== 0 ) {
					additional_offset = $open.height() + additional_offset;
				}

				$( 'html,body' ).animate( {
					scrollTop: $panel.offset().top - additional_offset
				}, 500 );
			} );

			// Add custom class to opened accordion for styling
			$toggle_link.on( 'click', function( e ) {
				setTimeout( function() {
					if ( $toggle_link.attr( 'aria-expanded' ) == 'true' ) {
						$panel.addClass( 'open' );
					} else {
						$panel.removeClass( 'open' );
					}
				}, 50 )
			} );

		} );
	};
	
	if( $( '.accordion.panel-group' ).length > 0 || $( '.link-boxes' ).length > 0 ) {
		$( document ).ready( _init );
	}
	
} )( jQuery );

module.exports = content_blocks;